import React from 'react'

export default function Pagination ({ slideIndex, prevSlide, nextSlide, setSlideIndex }) {
  return (
    <div className='number-row'>
      <a style={{ cursor: 'pointer' }} className='arrow arrow-left' onClick={() => prevSlide()}>
        ◀
      </a>
      {[1, 2, 3, 4].map(slide => (
        <a
          style={{ cursor: 'pointer' }}
          className={`number number-${slide} ${slideIndex === slide ? 'active' : ''}`}
          onClick={() => setSlideIndex(slide)}
        >
          {slide}
        </a>
      ))}
      <a style={{ cursor: 'pointer' }} className='arrow arrow-right' onClick={() => nextSlide()}>
        ▶
      </a>
    </div>
  )
}
